export const doesGracePeriodEnded = (givenDate: Date, gracePeriodInSecond: number) => {
  const currentTime = new Date();

  const timeToCompare = new Date(currentTime.getTime() - gracePeriodInSecond * 1000);

  return givenDate < timeToCompare;
};
